import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  DevNote,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import {
  billableClientOptions,
  cityStateListOptions,
  ContigentPaymentOptions,
  countryListOptions,
  countryOptions,
  IndemnificationOptions,
  invoiceFrequencyTypeOptions,
  jobOptions,
  LiquidatedDamageOptions,
  netTermsOptions,
  placementsOptions,
  placementVenderInvoiceFrequency,
  RightToHireOptions,
  SubContractingOptions,
  vendorTypeOptions,
} from "../../../../../../assets/data/projectData";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import useDropdownData from "../../../../../../hooks/useDropdownData";
import { JobStatus } from "../../../../../../assets/data/enumData";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { updateEmployeeStart } from "../../../../../../redux/slices/employee/employeeSlice";
import { addNewPlacementStart } from "../../../../../../redux/slices/placements/placementsSlice";
import { shortenCompanyName, dateFormator } from "../../../../../../utils";
import { fetchLatestUiid } from "../../../../../../redux/slices/common/latestUiidApi";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
const General = ({ setActiveTab, onCancel, currentPlacement, editData, incomingData }) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const [validationRules, setValidationRules] = useState({});
  const [reasonModal, setReasonModal] = useState(false);
  const containerRef = useRef(null);
  const [latestPlacementUiid, setLatestPlacementUiid] = useState(null);
  const [clickAddVendor, setClickAddVendor] = useState(false);
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const employmentType = currentEmployee?.employeeDetails?.employmentType;
  // const {
  //   // data: allClientsListOptions,
  //   // originalData: originalData,
  //   searchValue: allClientsListSearch,
  //   handleSearch: handleAllClientsListSearch,
  //   resetSearch: resetAllClientsListSearch,
  //   handleScroll: handleAllClientsListScroll,
  // } = useDropdownData("allClientsList", 5, {}, { orgId: organizationId });
  const initialFormData = {
    billableClient: editData?.jobInfo?.billClient || incomingData?.billableClient || "",
    placement: editData?.type === 2 ? "Permanent" : (editData?.type === 1 ? "Contract" : (incomingData?.placementType === 2 ? "Permanent" : (incomingData?.placementType === 1 ? "Contract" : ""))),
    //project: "",
    jobCode: editData?.jobInfo?.jobCode || incomingData?.jobCode || "",
    jobTitle: editData?.jobInfo?.jobTitle || incomingData?.jobTitle || "",
    startDate: editData?.jobInfo?.startDate || incomingData?.startDate || "",
    endDate: editData?.jobInfo?.endDate || incomingData?.endDate || "",
    projectedEndDate: editData?.jobInfo?.projectEndDate || "",
    jobStatus: editData?.jobInfo?.status 
      ? { label: editData.jobInfo.status === 1 ? "Active" : "Inactive", value: editData.jobInfo.status } 
      : (incomingData ? { label: "Active", value: 1 } : ""),
    autoUpdate: editData?.clientPlacement?.autoUpdateOnJobEndDate || false,
    searchforVendor: editData?.vendor?.id || "",
    workLocation: editData?.clientPlacement?.workLocation || [],
    name: editData?.vendor?.name || "",
    address: editData?.vendor?.address || "",
    addressOne: editData?.vendor?.addressOne || "",
    addressTwo: editData?.vendor?.addressTwo || "",
    country: editData?.vendor?.country || "",
    state: editData?.vendor?.state || "",
    city: editData?.vendor?.city || "",
    zipcode: editData?.vendor?.zipcode || "",
    netTerms: editData?.invoices?.netTerms || "",
    terminationNotice: editData?.invoices?.jobTerminationNotice || "",
    invoiceFrequency: editData?.vendor?.invFreq || "",
    frequencyStartDate: editData?.vendor?.freqStart || "",
    subcontracting: editData?.vendor?.subcontract || "",
    contingencyInPayment: editData?.vendor?.contingency || "",
    probationPeriod: editData?.vendor?.probation || "",
    rightToHire: editData?.vendor?.rightToHire || "",
    liquidatedDamages: editData?.vendor?.liqDamages || "",
    indemnification: editData?.vendor?.indemnification || "",
    comments: editData?.vendor?.comments || "",
    reason: editData?.jobInfo?.reason || "",
    inactiveEndDate: "",
  };
  const [originalData, setOriginalData] = useState([]);
  const [allClientsListOptions, setAllClientsListOptions] = useState([]);
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const [vendorDIA, setVendorDIA] = useState({});
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);
  useEffect(() => {
    const baseRules = {
      billableClient: { type: "select", required: true },
      placement: { type: "select", required: true },
      // project: { type: "text", required: true },
      jobCode: { type: "text", required: true },
      jobTitle: { type: "select", required: true },
      startDate: { type: "date", required: true },
      endDate: { type: "date", required: true },
      // projectedEndDate: { type: "date", required: true },
      jobStatus: { type: "select", required: true },
    };
    if (clickAddVendor) {
      baseRules.searchforVendor = { type: "select", required: true };
      baseRules.probationPeriod = {
        type: "text",
        required: true,
        number: true,
      };
    }
    setValidationRules(baseRules);
  }, []);
  ///////////////////Handel Save//////////////////////
  const handleSaveGeneral = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const userFormData = {
        jobInfo: {
          billClient: formData.billableClient?.value ?? formData.billableClient,
          jobCode: formData.jobCode,
          jobTitle: formData.jobTitle?.value ?? formData.jobTitle,
          startDate: dateFormator(formData.startDate, "month-day-year"),
          endDate: dateFormator(formData.endDate, "month-day-year"),
          // projectEndDate: formData.projectedEndDate,
          status: formData.jobStatus?.value ?? formData.jobStatus,
          ...(formData.jobStatus == 2 ? { reason: formData.reason } : {}),
        },
        clientPlacement: {
          placement: formData?.placement?.value || formData?.placement,
          autoUpdateOnJobEndDate: formData?.autoUpdate,
        },
      };
      if (clickAddVendor) {
        userFormData.vendor = {
          id: formData?.searchforVendor?.value ?? formData?.searchforVendor,
          invFreq: formData?.invoiceFrequency,
          freqStart: formData?.frequencyStartDate,
          subcontract: formData?.subcontracting,
          contingency: formData?.contingencyInPayment,
          probation: formData?.probationPeriod,
          rightToHire: formData?.rightToHire,
          liqDamages: formData?.liquidatedDamages,
          indemnification: formData?.indemnification,
          comments: formData?.comments,
        };
      }
      const uiid = fetchPerticularData?.uiid ?? "";
      const submissionData = filterEmptyValues(userFormData);
      dispatch(
        addNewPlacementStart({
          tPath: "placement",
          rsd: submissionData,
          ...(uiid && { uiid: uiid }),
          // rsn: "clientPlacementGeneral",
          rsn: `Client Placement ${submissionData.jobInfo.jobCode}`,
          payload: uiid
            ? [
                {
                  type: "SET",
                  value: {
                    type: (formData.placement === "Permanent" || incomingData?.placementType === 2) ? 2 : 1,
                    addedBy: loginUserUiid,
                    employeeId: employeeProfileUiid,
                    incomingPlacementId: incomingData?.incomingPlacementId,
                    entityId:
                      formData.billableClient?.value ?? formData.billableClient,
                    ...(incomingData?.team && { team: incomingData.team }),
                    ...submissionData,
                  },
                },
              ]
            : {
                type: (formData.placement === "Permanent" || incomingData?.placementType === 2) ? 2 : 1,
                addedBy: loginUserUiid,
                employeeId: employeeProfileUiid,
                incomingPlacementId: incomingData?.incomingPlacementId,
                entityId:
                  formData.billableClient?.value ?? formData.billableClient,
                ...(incomingData?.team && { team: incomingData.team }),
                ...submissionData,
              },
          onSuccess: async (payload) => {
            setActiveTab((prev) => prev + 1);
          },
        }),
      );
    } else {
      showToast(
        "please fill all the required feilds before saving",
        "error",
      );
    }
  };

  ///////////////////Handel Save End//////////////////////

  const handleCancel = () => {
    // console.log("cancel clicked....");
    if (onCancel) {
      onCancel();
    }
  };

  ///////////////////////////////////////////////////
  ///// Get select data form server
  ///////////////////////////////////////////////////

  ///////////////////////////////////////////////////
  ///// Get select data form server end
  ///////////////////////////////////////////////////

  ////////////////
  ////////////////
  ////////////////
  // useEffect(() => {
  //   const fetchLatestUiidData = async () => {
  //     try {
  //       const response = await fetchLatestUiid("placements");
  //       //console.log("Latest UIID Data:", response); // For debugging
  //       setLatestPlacementUiid(response.data.data.count + 1); // Modified this line
  //     } catch (error) {
  //       // console.error("Error fetching latest UIID:", error);
  //       showToast("Error fetching latest UIID", "error", 5000);
  //     }
  //   };

  //   fetchLatestUiidData();
  // }, []);
  useEffect(() => {
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("placements");
        const count = response?.data?.data?.count;

        if (typeof count === "number") {
          setLatestPlacementUiid(count + 1);
        } else {
          setLatestPlacementUiid(1);
        }
      } catch (error) {
        // showToast("Error fetching latest UIID", "error", 5000);
        setLatestPlacementUiid(1);
      }
    };

    fetchLatestUiidData();
  }, []);

  // useEffect(() => {
  //   if (formData.billableClient && latestPlacementUiid) {
  //     // Find the selected client's name from the options
  //     const selectedClient = allClientsListOptions.find(
  //       (option) => option.value === formData.billableClient
  //     );

  //     if (selectedClient) {
  //       const clientName = selectedClient.label;
  //       const shortName = shortenCompanyName(clientName);
  //       const newJobCode = `${shortName}-${latestPlacementUiid}`;

  //       // Update the jobCode in the form
  //       setFormData((prevData) => ({
  //         ...prevData,
  //         jobCode: newJobCode,
  //       }));
  //     }
  //   }
  // }, [
  //   formData.billableClient,
  //   latestPlacementUiid,
  //   allClientsListOptions,
  //   originalData,
  // ]);
  useEffect(() => {
    // Skip if incomingData is present — incoming values take priority
    if (incomingData) return;
    const clientPlacementGeneral = currentPlacement?.clientPlacementGeneral;
    if (clientPlacementGeneral) {
      handleChange(
        "billableClient",
        clientPlacementGeneral?.jobInfo?.billClient,
      );
      handleChange("jobCode", clientPlacementGeneral?.jobInfo?.jobCode);
      handleChange("jobTitle", clientPlacementGeneral?.jobInfo?.jobTitle);
      handleChange("startDate", clientPlacementGeneral?.jobInfo?.startDate);
      handleChange("endDate", clientPlacementGeneral?.jobInfo?.endDate);
      handleChange(
        "projectedEndDate",
        clientPlacementGeneral?.jobInfo?.projectEndDate,
      );
      handleChange("jobStatus", clientPlacementGeneral?.jobInfo?.status);
      handleChange(
        "placement",
        clientPlacementGeneral?.clientPlacement?.placement,
      );
    }
  }, [currentPlacement]);



  ////////////////
  ////////////////
  ////////////////
  const handleChangeUpdateJobCode = (options, data, value) => {
    setAllClientsListOptions(data);
    setOriginalData(options);
    // Find the selected client's name from the options
    const selectedClient = data.find((option) => option.uiid === value);
    if (selectedClient) {
      // If incomingData already provided a jobCode, don't overwrite it with the auto-generated one
      if (incomingData?.jobCode) {
        setFormData((prevData) => ({
          ...prevData,
          jobCode: incomingData.jobCode,
        }));
        return;
      }
      const newJobCode = `${selectedClient.shortCode}-${String(
        (selectedClient.jobCount || 0) + 1,
      ).padStart(3, "0")}`;
      // Update the jobCode in the form
      setFormData((prevData) => ({
        ...prevData,
        jobCode: newJobCode,
      }));
    }
  };

  const handleAddClickVendor = () => {
    setClickAddVendor(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      // Skip fetching when incomingData is provided — incoming values take priority
      if (incomingData) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "entityId jobInfo uiid clientPlacement.placement clientPlacement.autoUpdate vendor",
            ref: "Client Vendor",
            incl: ["uiid businessName", "uiid businessName"],
          },
        });
        const data = response?.data?.data;
        if (data) {
          setFetchPerticularData(data);
          handleChange(
            "billableClient",
            data?.jobInfo?.billClient?.businessName
              ? {
                  label: data?.jobInfo?.billClient?.businessName,
                  value: data?.jobInfo?.billClient?.uiid,
                }
              : "",
          );
          handleChange("projectedEndDate", data?.jobInfo?.projectEndDate || "");
          handleChange("placement", data?.clientPlacement?.placement || "");
          handleChange(
            "autoUpdateOnJobEndDate",
            data?.clientPlacement?.autoUpdate || "",
          );
          handleChange("jobTitle", data?.jobInfo?.jobTitle || "");
          handleChange("jobCode", data?.jobInfo?.jobCode || "");
          handleChange("jobStatus", data?.jobInfo?.status || "");
          handleChange("startDate", data?.jobInfo?.startDate || "");
          handleChange("endDate", data?.jobInfo?.endDate || "");
          const vendor = data?.vendor ?? {};

          if (Object.keys(vendor).length > 0) {
            setClickAddVendor(true);

            handleChange(
              "searchforVendor",
              vendor?.id?.uiid
                ? { label: vendor?.id?.businessName, value: vendor?.id?.uiid }
                : "",
            );

            handleChange("invoiceFrequency", vendor?.invFreq ?? "");
            handleChange("frequencyStartDate", vendor?.freqStart ?? "");
            handleChange("subcontracting", vendor?.subcontract ?? undefined);
            handleChange(
              "contingencyInPayment",
              vendor?.contingency ?? undefined,
            );
            handleChange(
              "probationPeriod",
              vendor?.probation ? `${vendor.probation}` : "",
            );
            handleChange("rightToHire", vendor?.rightToHire ?? undefined);
            handleChange("liquidatedDamages", vendor?.liqDamages ?? undefined);
            handleChange(
              "indemnification",
              vendor?.indemnification ?? undefined,
            );
            handleChange("comments", vendor?.comments ?? "");
          }
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  useEffect(() => {
    const fetchVendorDetails = async () => {
      if (formData?.searchforVendor) {
        const uiid =
          formData?.searchforVendor?.value ?? formData?.searchforVendor;
        if (!uiid) return;
        const url = ENDPOINTS.VENDORS.GET_BY_UIID;
        try {
          const response = await axiosRequest({
            method: "GET",
            url,
            params: {
              coll: "Vendor",
              fil: JSON.stringify({ uiid: { type: "NONE", value: uiid } }),
              cache: false,
              ret: "businessName generalInfo uiid vendor",
            },
          });
          if (response?.success) {
            const vendorData = response?.data?.data || {};
            const netTerms = vendorData?.generalInfo?.netTerms;
            const terminationNotice =
              vendorData?.generalInfo?.terminationNotice;
            if (netTerms) {
              handleChange("netTerms", netTerms);
            }
            if (terminationNotice) {
              handleChange("terminationNotice", terminationNotice);
            }
            handleChange("name", vendorData?.businessName || "");
            handleChange(
              "addressOne",
              vendorData?.generalInfo?.locations[0]?.address1 || "",
            );
            handleChange(
              "addressTwo",
              vendorData?.generalInfo?.locations[0]?.address2 || "",
            );
            handleChange(
              "country",
              vendorData?.generalInfo?.locations[0]?.country || "",
            );
            handleChange(
              "state",
              vendorData?.generalInfo?.locations[0]?.state || "",
            );
            handleChange(
              "city",
              vendorData?.generalInfo?.locations[0]?.city || "",
            );
            handleChange(
              "zipcode",
              vendorData?.generalInfo?.locations[0]?.zipCode || "",
            );

            setVendorDIA(vendorData);
          }
        } catch (error) {}
      }
    };
    fetchVendorDetails();
  }, [formData?.searchforVendor]);

  console.log("formdata in vendor", formData);
  // useEffect(() => {
  //   if (formData?.jobStatus === 2) {
  //     setReasonModal(true);
  //   } else {
  //     setReasonModal(false);
  //   }
  // }, [formData.jobStatus]);

  const handleInactiveReason = () => {
    if (formData?.jobStatus !== 2) return;

    if (!formData?.reason || !formData?.inactiveEndDate) {
      showToast("End Date / Reason is required", "error");
      return;
    }

    const endDate = new Date(formData?.inactiveEndDate);
    const now = new Date();

    if (endDate < now) {
      handleChange("endDate", formData?.inactiveEndDate);
      handleChange("jobStatus", 2);
      setReasonModal(false);
    } else {
      handleChange("endDate", formData?.inactiveEndDate);
      handleChange("jobStatus", 1);
      setReasonModal(false);
    }
  };
  const handleReasonClose = () => {
    setReasonModal(false);
    handleChange("jobStatus", 1);
  };

  return (
    // <div className="w-full px-8 py-6 min-h-[69vh] overflow-auto">
    <div className="w-full px-8 py-6 overflow-auto">
      <DevNote>
        Job Status:{formData?.jobStatus?.label || formData?.jobStatus}
        Reason : {formData.reason}
      </DevNote>
      <div className="grid grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6">
        <FormFieldSet
          title="Select Client"
          type="allClientsSorted"
          label="DynamicSelect"
          placeholder="Select Client"
          showNames={true}
          value={formData.billableClient}
          // onChange={(e) => setSelectClient(e)}
          onChange={(value) => handleChange("billableClient", value)}
          showSearch
          onSelectItem={
            (options, data, value) => {
              handleChangeUpdateJobCode(options, data, value);
            }
            // handleSelectClientNVender(options, data, value)
          }
        />
        <FormFieldSet
          type="placementsList"
          title={"Placement"}
          placeholder="Select Placement"
          value={formData.placement}
          onChange={(value) => handleChange("placement", value)}
          error={errors.placement}
          // options={placementsOptions}
          showButton
          showSearch
        />

        {/* <FormFieldSet
          type="text"
          title={"Project"}
          placeholder="Select Project"
          value={formData.project}
          onChange={(value) => handleChange("project", value)}
          error={errors.project}
          showSearch
        /> */}

        <FormFieldSet
          type="text"
          title={"Job Code"}
          placeholder="Select Client for Job Code"
          value={formData.jobCode}
          //onChange={(value) => handleChange("jobCode", value)}
          //error={errors.jobCode}
          disabled
        />

        {/* <FormFieldSet
          type="select"
          title={"Job Title"}
          placeholder="Select Job Title"
          keyname={"jobTitles"}
          options={jobTitleOptions}
          value={formData.jobTitle}
          onChange={(value) => handleChange("jobTitle", value)}
          error={errors.jobTitle}
          showSearch
          searchValue={jobTitlesSearch}
          onSearch={handleJobTitlesSearch}
          onClose={resetJobTitlesSearch}
          showButton
          alertName={"addJobTitles"}
          icon={"add"}
          required
          handleScroll={() => handleJobTitlesScroll(containerRef)}
          refData={containerRef}
        /> */}
        <FormFieldSet
          type="jobTitle"
          title="Job Title"
          placeholder="Enter Job Title"
          value={formData.jobTitle}
          onChange={(value) => handleChange("jobTitle", value)}
          error={errors.jobTitle}
          showSearch
          showButton
        />

        <FormFieldSet
          type="datepicker"
          title={"Start Date"}
          placeholder="Select Start Date"
          value={formData.startDate}
          onChange={(value) => {
            handleChange("startDate", value);
            handleChange("frequencyStartDate", value);
          }}
          error={errors.startDate}
          maxDate={formData.endDate}
          showDropdown={false}
        />

        <FormFieldSet
          type="datepicker"
          title={"End Date"}
          placeholder="Select End Date"
          value={formData.endDate}
          onChange={(value) => handleChange("endDate", value)}
          error={errors.endDate}
          minDate={formData?.startDate}
          showDropdown={false}
        />
        <FormFieldSet
          type="select"
          title={"Job Status"}
          placeholder="Select Job Status"
          value={formData.jobStatus}
          onChange={(value) => {
            handleChange("jobStatus", value);
            if (value == 2) {
              setReasonModal(true);
            } else {
              setReasonModal(false);
            }
          }}
          error={errors.jobStatus}
          options={JobStatus}
        />
        {/* said to be hide by vikranth on 25-08 */}
        {/* <FormFieldSet
          type="toggle"
          title={"Auto Update on Job End Date"}
          isChecked={formData?.autoUpdate}
          value={formData?.autoUpdate}
          onChange={() => handleChange("autoUpdate", !formData.autoUpdate)}
          error={errors.autoUpdate}
        /> */}
      </div>
      {/* <DevNote>Add vendor show only constructors</DevNote> */}
      {[2, 3].includes(employmentType) && (
        <div className="my-3">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle
                  title={clickAddVendor ? "Vendor Details" : ""}
                  tag="h6"
                />
              </div>
            }
            RightSection={
              <>
                {/* {[2, 3].includes(employmentType) && ( */}
                <Button
                  title="Add Vendor"
                  size="sm"
                  icon="add"
                  onClick={handleAddClickVendor}
                />
                {/* )} */}
              </>
            }
          />
        </div>
      )}

      {clickAddVendor && (
        <div className="grid grid-cols-2 xl:grid-cols-3 max-w-7xl gap-x-8 gap-y-6">
          <FormFieldSet
            type="allVendorsList"
            title={""}
            placeholder="Search For Vendor"
            // noTitle
            value={formData.searchforVendor}
            onChange={(value) => handleChange("searchforVendor", value)}
            error={errors.searchforVendor}
            showSearch
          />
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            // noTitle
            options={[
              {
                label: "Set as Work Location",
                value: true,
              },
            ]}
            values={formData.workLocation || []}
            onChange={(value) => handleChange("workLocation", value)}
            multiple
            error={errors.workLocation}
          />
          <FormFieldSet
            type="text"
            title={"Name"}
            placeholder="Enter Name"
            value={formData.name}
            onChange={(value) => handleChange("name", value)}
            error={errors.name}
          />
          <FormFieldSet
            type="select"
            title={"Select Address"}
            placeholder="Select Address"
            value={formData.address}
            onChange={(value) => handleChange("address", value)}
            error={errors.address}
            options={""}
          />
          <FormFieldSet
            type="text"
            title={"Address Line 1"}
            placeholder="Enter Address Line 1"
            value={formData.addressOne}
            onChange={(value) => handleChange("addressOne", value)}
            error={errors.addressOne}
          />
          <FormFieldSet
            type="text"
            title={"Address Line 2"}
            placeholder="Enter Address Line 2"
            value={formData.addressTwo}
            onChange={(value) => handleChange("addressTwo", value)}
            error={errors.addressTwo}
          />
          <FormFieldSet
            type="select"
            title={"Country"}
            placeholder="Select Country"
            value={formData.country}
            onChange={(value) => handleChange("country", value)}
            error={errors.country}
            options={countryOptions}
          />
          <FormFieldSet
            type="select"
            title={"State"}
            placeholder="select State"
            value={formData.state}
            onChange={(value) => handleChange("state", value)}
            error={errors.state}
            options={cityStateListOptions}
          />
          <FormFieldSet
            type="text"
            title={"City"}
            placeholder="Enter City"
            value={formData.city}
            onChange={(value) => handleChange("city", value)}
            error={errors.city}
          />
          <FormFieldSet
            type="text"
            title={"Zipcode"}
            placeholder="Enter Zipcode"
            value={formData.zipcode}
            onChange={(value) => handleChange("zipcode", value)}
            error={errors.zipcode}
          />
          <FormFieldSet
            // type="netTerm"
            type="select"
            title={"Net Terms"}
            placeholder="Select Net Terms"
            options={netTermsOptions}
            value={formData.netTerms}
            onChange={(value) => handleChange("netTerms", value)}
            error={errors.netTerms}
            showSearch
            // showButton
            // options={netTermsOptions}
          />
          <FormFieldSet
            type="text"
            title={"Termination Notice"}
            placeholder="Enter Termination Notice"
            value={formData.terminationNotice}
            onChange={(value) => handleChange("terminationNotice", value)}
            error={errors.terminationNotice}
          />
          <FormFieldSet
            type="select"
            title={"Invoice Frequency"}
            placeholder="Select Invoice Frequency"
            value={formData.invoiceFrequency}
            onChange={(value) => handleChange("invoiceFrequency", value)}
            error={errors.invoiceFrequency}
            options={placementVenderInvoiceFrequency}
          />
          <FormFieldSet
            // type="text"
            type="datepicker"
            // title={"Start Date"}
            title={"Frequency Start Date"}
            placeholder="Enter Frequency Start Date"
            value={formData.frequencyStartDate}
            onChange={(value) => handleChange("frequencyStartDate", value)}
            error={errors.frequencyStartDate}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Subcontracting"}
            placeholder="Select Subcontracting"
            value={formData.subcontracting}
            onChange={(value) => handleChange("subcontracting", value)}
            error={errors.subcontracting}
            options={SubContractingOptions}
          />
          <FormFieldSet
            type="select"
            title={"Contingency in Payment"}
            placeholder="Select Contingency in Payment"
            value={formData.contingencyInPayment}
            onChange={(value) => handleChange("contingencyInPayment", value)}
            error={errors.contingencyInPayment}
            options={ContigentPaymentOptions}
          />
          <FormFieldSet
            type="text"
            title={"Probation Period"}
            placeholder="Enter Probation Period"
            value={formData.probationPeriod}
            onChange={(value) => handleChange("probationPeriod", value)}
            error={errors.probationPeriod}
          />
          <FormFieldSet
            type="select"
            title={"Right to Hire"}
            placeholder="Select Right to Hire"
            value={formData.rightToHire}
            onChange={(value) => handleChange("rightToHire", value)}
            error={errors.rightToHire}
            options={RightToHireOptions}
          />
          <FormFieldSet
            type="select"
            title={"Liquidated Damages"}
            placeholder="Select Liquidated Damages"
            value={formData.liquidatedDamages}
            onChange={(value) => handleChange("liquidatedDamages", value)}
            error={errors.liquidatedDamages}
            options={LiquidatedDamageOptions}
          />
          <FormFieldSet
            type="select"
            title={"Indemnification"}
            placeholder="Select Indemnification"
            value={formData.indemnification}
            onChange={(value) => handleChange("indemnification", value)}
            error={errors.indemnification}
            options={IndemnificationOptions}
          />
          <FormFieldSet
            type="textArea"
            title={"Comments"}
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
            rows={5}
          />
        </div>
      )}
      <div className="flex gap-3 justify-end">
        <Button
          title={"Cancel"}
          variant="outlined"
          onClick={() => handleCancel()}
        />
        <Button title={"Save"} onClick={handleSaveGeneral} />
      </div>
      <Modal
        isOpen={reasonModal}
        title={"Job Inactive Reason"}
        onClose={handleReasonClose}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-3xl max-h-full"
      >
        <div className="flex-1 h-full w-full">
          <div className="flex flex-col gap-2">
            <FormFieldSet
              type="datepicker"
              title={"End Date"}
              placeholder="Select End Date"
              value={formData.inactiveEndDate}
              onChange={(value) => handleChange("inactiveEndDate", value)}
              showDropdown={false}
            />
            <FormFieldSet
              type="textArea"
              title={"Reason"}
              placeholder="Enter Reason To Inactive"
              value={formData.reason}
              onChange={(value) => handleChange("reason", value)}
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <Button
              title={"Cancel"}
              variant="outlined"
              onClick={handleReasonClose}
            />
            <Button title={"Confirm"} onClick={handleInactiveReason} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default General;
